export default __webpack_public_path__ + "static/media/sports.a4467068.svg";